(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsMapController', TabObjectsMapController);

    TabObjectsMapController.$inject = ['$state', '$window', 'TabObjectsMap', 'ObjectMap', 'pagingParams'];

    function TabObjectsMapController($state, $window, TabObjectsMap, ObjectMap, pagingParams) {
        var vm = this;
        vm.applyFilter = applyFilter;
        vm.object = [];
        vm.mapStyle = {};
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleets = [];
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedCondition = {};
        vm.oldURL = document.baseURI;
        vm.back = function () {
            window.location.href = vm.oldURL;
        };
        var map = ObjectMap.build("object-map");
        var markersLayer = new L.LayerGroup();
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);
        resizeFrame();

        vm.oldURL = document.baseURI;
        vm.back = function () {
            window.location.href = vm.oldURL;
        };

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        vm.consoleL = [];
        var boundsArray = [];
        var markersCluster = null;

        function loadAll() {
            vm.locations = [];
            vm.icons = [];
            vm.labels = [];
            vm.consoleL = [];
            boundsArray = [];
            var data = {
                fleet: vm.fleet.id,
                objectType: vm.objectType.id
            };
            TabObjectsMap.query(data, onSuccess, onError);
        }

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if(!lat || !lng || lat === "null" || lng === "null"){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if(!lat || !lng || lat === "null" || lng === "null"){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccess(result) {
            markersLayer.clearLayers();
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if (coord !== null) {
                    var consoleLink = '#/dashboards/tab-objects-dashboard/' + object.fleet.id + '/' + object.id + '/' + object.objectType.id;

                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIcon(object.objectTracked, object.level));
                        vm.labels.push({name: object.objectName, warning: object.warnings});
                        vm.consoleL.push(consoleLink);
                    }

                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIcon(object.objectTracked, object.level)})
                    //     .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + object.objectName + "</a><br\><span>Warning: " + object.warnings + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            // markersLayer.addTo(map);
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }

        function onError() {
        }

        function resizeFrame() {
            var offsetY = 140;
            var mapHeight = $window.innerHeight;
            mapHeight = mapHeight > 600 ? mapHeight - offsetY : 600;
            vm.mapStyle.height = mapHeight;
            var sizeX = Math.round((mapHeight / 100));
            // if (!$scope.$$phase)
            //     $scope.$apply();
        }

        function transition(notify) {

            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id
            }, {notify: notify, location: "replace"});
        }

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            }
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            loadAll();
            transition(false);
        }

        function initMap() {
            // rimuovi il cluster precedente dalla mappa se esiste
            if (markersCluster) {
                map.removeLayer(markersCluster);
            }

            markersCluster = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var consoleLink = vm.consoleL[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon})
                    .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + title.name + "</a><br\><span>Warning: " + title.warning + "</span>");
                marker.addTo(markersCluster);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markersCluster.addTo(map);
        }
    }
})();
